// extracted by mini-css-extract-plugin
export default {"modal_animation_duration":"200ms","fallbackButton":"onfido-sdk-ui-Button-fallbackButton"};